import { useQuery } from 'react-query';
import {
  DEFAULT_PERMISSIONS_LIST,
  PERMISSION_LISTS,
} from '../constants/permissionsList';

function useUserPermissions(type = DEFAULT_PERMISSIONS_LIST) {
  const fetchDataUser = async () => {
    try {
      const response = await PERMISSION_LISTS[type].fn();

      return response.data?.[PERMISSION_LISTS[type].key] || [];
    } catch (error) {
      console.error('Failed to fetch user permissions data:', error);
      throw error;
    }
  };

  return useQuery({
    queryKey: ['me-permissions', type],
    queryFn: fetchDataUser,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    retry: false,
    staleTime: Infinity,
    cacheTime: Infinity,
  });
}

export default useUserPermissions;
